'use strict';
var noResultsDialogDisplayer = require('od-modules/ui/no_results_dialog_displayer');
var trackingUtils = require('od-modules/utils/tracking.utils');
var sortTypes = require('../../modules/utils/sort_types');

var refreshSummary = function(params) {
    var toogle = params.numResults === params.numFilteredResults;
    $('#filter').find('.results_reset_filters').toggleClass('hidden', toogle);
    $('.filter_layer').find('.results_reset_filters').toggleClass('hidden', toogle);
};
var preventPullToRefresh = require('../../modules/utils/prevent_pull_to_refresh.js');

module.exports = {
    init: function() {
        this.options = Odigeo.Utils.parseOptions(this.options);
        Odigeo._.defaults(this.options, {tests: {}});
    },

    setTag: function(model) {
        this.model.setLabel(model);
    },

    setFilterTitleActive: function(triggeredFilter) {
        this.view.setFilterTitleActive(triggeredFilter);
    },

    sortResultsBy: function(sortType) {
        this.model.currentSorting = sortType;
        this.model.dataApplySearchFilters = true;
        this.model.mode = 'filterandsort';
        this.model.refresh();
    },

    hideSearchingScreen: function(params) {
        this.view.hideSearchingScreen(params);
    },

    hideFiltersLoading: function(params) {
        this.view.hideFiltersLoading(params);
    },

    setActiveFilter: function(params) {
        this.view.setActiveFilter(params.tab, params.activateAllFlights);
    },

    setActiveFilterByName: function(params) {
        this.view.setActiveFilterByName(params.filterName, params.activateAllFlights);
    },

    setActiveLeg: function(params) {
        this.view.setActiveLeg(params.tab);
    },
    toggleTabVisibility: function(params) {
        this.view.toggleTabVisibility(params.tab);
    },
    toggleVisibility: function(visible) {
        if (this.options.isFiltersLayer) {
            this.view.toggleFiltersContainersVisibility(visible);
        } else {
            this.view.$el.toggleClass('hidden', !visible);
        }
    },
    handleTouchables: function() {
        this.view.handleTouchables();
    },

    /**
     * clear active filters
     */
    resetFilters: function() {
        this.model.mode = 'reset';
        this.refresh();
    },
    /**
     * reset and resort elements
     */
    resetAndSort: function() {
        this.model.mode = 'resetandsort';
        this.model.refresh();
    },
    /**
     * load filters
     */
    loadFilters: function() {
        this.view.filtersAreInitialized = false;

        this.view.setActiveFilter(-1, true);
        this.model.mode = 'load';
        this.model.refresh();
    },
    trackOnLoadEvents: function() {
        this.model.waitForReceivingAirportModels(this.tripType)
            .then(function(requestedModels) {
                if (requestedModels.originsFilterModel[0].selectedItems.length > 1 ||
                    requestedModels.destinationsFilterModel[0].selectedItems.length > 1) {
                    trackingUtils.trackEvent('on_load_events', 'airport_filters_available');
                }
            });
        Odigeo.trigger(this.id + ':requestModel', 'origins', 'airports_filter', 0);
        Odigeo.trigger(this.id + ':requestModel', 'destinations', 'airports_filter', 0);
    },
    activeFilterHandler: function() {
        return {
            activeFilter: this.activeFilter,
            tripType: this.tripType,
        };
    },

    receiveFilterRequest: function(requestType, filterName) {
        this.model.receiveFilterRequest(requestType, filterName);
    },
    checkNullFilters: function(applyFiltersTrigger) {
        this.view.checkNullFilters(applyFiltersTrigger);
    },
    storeFiltersMetadataStatus: function() {
        this.model.storeFiltersMetadataStatus();
    },
    updateFiltersMetadataTemporal: function(filterInfo, requestType, index) {
        this.model.updateFiltersMetadataTemporal(filterInfo, requestType, index);
    },
    loadFilterModelsMetadata: function() {
        if (Odigeo._.isEmpty(this.model.filtersMetadataToRestore.timeFilterModel)) {
            this.resetAndSort();
        } else {
            this.model.onReceiveFilterModels(this.model.filtersMetadataToRestore, true);
        }
        Odigeo.trigger('filters-manager:closeFiltersLayer');
    },
    resetFiltersMetadataToRestore: function() {
        this.model.resetFiltersMetadataToRestore();
    },
    resetFiltersMetadataTemporal: function() {
        this.model.resetFiltersMetadataTemporal();
    },

    // Current selected flight (0 to numFlights-1)
    activeFlight: 0,
    // Current open filter tab (-1 all closed/0-3 filters )
    activeFilter: -1,
    // Trip type (roundTrip/oneWay/multipleTrip)
    tripType: 'roundTrip',
    // number of flights of the performed search (1 for oneWay, 2 for roundTrip / 2-6 for multipleTrip)
    numFlights: 1,
    // control param to try to detect if the user is refreshing the screen. Not working yet.
    refreshingScreen: false,

    // -------------- handlers ----------
    receiveFilterInfo: function(info, type, index) {
        this.model.receiveFilterInfo(info, type, index);
    },
    doCheckNonStopsFilter: function(skipTracking) {
        Odigeo.trigger(this.id + ':check-non-stopover-filter', {
            stop: 0,
            tabId: 0,
            skipTracking: skipTracking,
        });
    },
    setCurrentSorting: function(sortType) {
        this.model.currentSorting = sortType;
    },
    doSelectPaymentMethod: function(params) {
        var filterRequestData = {};
        filterRequestData.paymentMethodFilterModel = params;
        this.model.clearRequest({silent: true});
        this.model.set(filterRequestData);
        this.model.mode = 'filterandsort';
        this.model.refresh();
    },
    showNoFilteredResultsScreen: function() {
        noResultsDialogDisplayer.showNoFilteredResultsScreen({
            action: 'filters-manager:resetLastFilterUsed',
        });
        trackingUtils.trackEvent('results_filters', 'filtering_no_results_found', 'flights_results');
    },
    filterRequest: function(param) {
        this.model.filterRequest(param);
    },
    filterTransportTypeRequest: function(selectedItems) {
        this.model.filterTransportTypeRequest(selectedItems);
    },
    onStopoversFilter: function(id) {
        Odigeo.trigger(this.widgetType + ':filtersLoading');
        this.model.filterRequest(['stopovers']);
        this.view._trackStopoversFilter(id);
    },
    completeFlightDurationFilter: function(id, filterReq) {
        this.model.mode = 'filter';
        this.model.currentSorting = sortTypes.byDuration.value;
        Odigeo.trigger(this.widgetType + ':filtersLoading');
        this.model.filterRequest(filterReq);
        if (!Odigeo._.isUndefined(id)) {
            Odigeo.requireWidget('flexible-dates', 'flexible_dates', function(flexibleDates) {
                flexibleDates.execute('selectBestPrice');
            });
            this.view._tracktEvent(id.substr(-1) + '_segment_duration_' + this.view.$widget.find('#' + id).attr('to'));
        }
    },
    setFastestFlightDurationFilter: function(id) {
        this.completeFlightDurationFilter(id, ['fastestflightduration']);
    },
    // TODO currently this function is moved here because is used for mobile.handler.results and mobile.handler.filter.
    // TODO However this code does not follow the code conventions and must be reviewed and refactored.
    applyFilter: function(idx, mode, params) {
        $('#filters-tabs').trigger('setStyleModified', idx);
        Odigeo.trigger(`${this.id}:invalidate-results`, mode, params);
        Odigeo.trigger(`${this.id}:updateResumeFlightsResultsDp`, params);
        refreshSummary(params);
    },
    clearFilter: function(params) {
        $('#filters-tabs').trigger('setStyleDefault');
        Odigeo.trigger(`${this.id}:clear-filter`, params);
        Odigeo.trigger(`${this.id}:updateResumeFlightsResultsDp`, params);
        refreshSummary(params);
        this.view.clearSummaryTagsInMultiTrips();
    },
    setPreventPullRefresh: function() {
        window.addEventListener('touchstart', preventPullToRefresh.touchstartHandler, {passive: false});
        window.addEventListener('touchmove', preventPullToRefresh.touchmoveHandler, {passive: false});
    },
    unsetPreventPullRefresh: function() {
        window.removeEventListener('touchstart', preventPullToRefresh.touchstartHandler);
        window.removeEventListener('touchmove', preventPullToRefresh.touchmoveHandler);
    },
    onFiltersUpdated: function(idx, filter, isFiltered) {
        this.model.onFiltersUpdated(idx, filter, isFiltered);
    },
    repaintSliders: function() {
        var filtersToReset = [1, 3];
        var activeFilter = this.activeFilter;
        if (Odigeo._.includes(filtersToReset, activeFilter)) {
            this.view.$cachedSelectors[this.view.filterContainers[activeFilter] + this.activeFlight].trigger('resize');
        }
    },
    setLastFilterUsed: function(filterName, filterIndex) {
        this.model.set({
            lastFilterName: filterName,
            lastFilterIndex: filterIndex,
        });
    },
    resetLastFilterUsed: function() {
        Odigeo.trigger(this.id + ':reset', this.model.get('lastFilterName'), this.model.get('lastFilterIndex'));
    },
    updateAirlinesIfFreeRebookingFilter(isChecked, airlinesList) {
        this.view.updateAirlinesIfFreeRebookingFilter(isChecked, airlinesList);
    },
    enableAllAirlineInputs() {
        this.view.enableAllAirlineInputs();
    },
};
